import { adminApi } from './admin-api';
import type { AdminFilters, AdminInvoice, BillingOverview, PlanConfig, PaginatedResponse } from '@/types/admin.types';

export const adminBillingService = {
  getOverview: async (): Promise<BillingOverview> => {
    const response = await adminApi.get('/admin/billing/overview');
    return response.data;
  },

  getInvoices: async (filters: AdminFilters = {}): Promise<PaginatedResponse<AdminInvoice>> => {
    const params = new URLSearchParams();
    if (filters.page) params.set('page', String(filters.page));
    if (filters.limit) params.set('limit', String(filters.limit));
    if (filters.search) params.set('search', filters.search);
    if (filters.sortBy) params.set('sortBy', filters.sortBy);
    if (filters.sortOrder) params.set('sortOrder', filters.sortOrder);
    if (filters.dateFrom) params.set('dateFrom', filters.dateFrom);
    if (filters.dateTo) params.set('dateTo', filters.dateTo);
    const response = await adminApi.get(`/admin/billing/invoices?${params.toString()}`);
    return response.data;
  },

  getPlans: async (): Promise<PlanConfig[]> => {
    const response = await adminApi.get('/admin/billing/plans');
    return response.data;
  },

  updatePlan: async (uuid: string, data: Partial<PlanConfig>): Promise<PlanConfig> => {
    const response = await adminApi.patch(`/admin/billing/plans/${uuid}`, data);
    return response.data;
  },

  createPlan: async (data: Omit<PlanConfig, 'uuid'>): Promise<PlanConfig> => {
    const response = await adminApi.post('/admin/billing/plans', data);
    return response.data;
  },

  getRevenueData: async (period: string = '12m'): Promise<Record<string, unknown>> => {
    const response = await adminApi.get(`/admin/billing/revenue?period=${period}`);
    return response.data;
  },

  getFailedPayments: async (filters: AdminFilters = {}): Promise<PaginatedResponse<AdminInvoice>> => {
    const params = new URLSearchParams();
    if (filters.page) params.set('page', String(filters.page));
    if (filters.limit) params.set('limit', String(filters.limit));
    const response = await adminApi.get(`/admin/billing/failed-payments?${params.toString()}`);
    return response.data;
  },

  retryPayment: async (invoiceUuid: string): Promise<{ message: string }> => {
    const response = await adminApi.post(`/admin/billing/invoices/${invoiceUuid}/retry`);
    return response.data;
  },
};
